import { render, staticRenderFns } from "./right-bottom.vue?vue&type=template&id=471c967e&scoped=true&"
import script from "./right-bottom.vue?vue&type=script&lang=js&"
export * from "./right-bottom.vue?vue&type=script&lang=js&"
import style0 from "./right-bottom.vue?vue&type=style&index=0&id=471c967e&scoped=true&lang=css&"
import style1 from "./right-bottom.vue?vue&type=style&index=1&id=471c967e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c967e",
  null
  
)

export default component.exports